export default {
  state: {
    items: [
      {
        value: 'individual',
        text: 'Individual'
      },
      {
        value: 'corporate',
        text: 'Corporate'
      }
    ]
  }
}
